<template>
  <!-- <div :style="{ height: 'calc(100% + ' - '60px)'}"> -->
  <!-- <Scroll
    :on-reach-bottom="handleReachEdge"
    :height="scrollHeight"
    loading-text="loading..."
  > -->
  <div class="save-items common-flex common-justify-between">
    <div class="list">
      <rCenterHeader :width="1150" :list="headerMenu">
        <div class="search" slot="search">
          <form>
            <!-- :loading="loading3" -->
            <Select
              v-model="orderNums"
              ref="orderNumSelect"
              filterable
              :remote-method="remoteMethod"
              @on-change="changeMethod"
              :loading="loading"
              :label-in-value="true"
              style="width: 380px; color: #081938; height: 40px"
              :placeholder="$t('fabricLibrary.search')"
              clearable
              @keydown.enter.native.prevent="searchs('')"
              @on-clear="clear"
            >
              <Option
                v-for="(option, index) in orderNumList"
                :value="option.orderCode + option.customOrderNo"
                :key="index"
                :label="option.orderCode"
              >
                <!-- {{ option.orderCode }}({{ option.source}}) -->
                <div class="common-flex common-justify-between">
                  <span>{{ option.customOrderNo ? option.orderCode + ' | ' + option.customOrderNo : option.orderCode }}</span>
                  <span style="float: right; color: #ccc">{{
                      option.source
                    }}</span>
                </div>
              </Option>
            </Select>
            <!-- <Input
              size="large"
              v-model="params.keyWord"
              icon="ios-search"
              @on-click="search('')"
              @keydown.enter.native.prevent="search('')"
              :placeholder="$t('fabricLibrary.search')"
              style="width: 380px; color: #081938"
            /> -->
            <Button
              @click="filterClick"
              class="filter"
              size="large"
              type="primary"
            >
              <span class="iconfont iconshaixuan"></span>
              {{ $t("fabricLibrary.filter") }}
            </Button>

            <Button
              class="filter"
              size="large"
              type="primary"
              @click="handleExport"
            >
              <span>Export</span>
            </Button>
          </form>
        </div>
      </rCenterHeader>
      <div class="product-list">
        <rCartOrder
          @checkOptions="checkOptions"
          @deleteOrder="deleteOrder"
          @customerDetails="customerDetails"
          @changeTip="changeTip"
          @add="add"
          @consumptionQuery="consumptionQuery"
          @move="move"
          @edit="handleCartEdit"
          @buyAgain="handleBuyAgain"
          @changeAdd="changeAdd"
          @changeCheck="changeCheck"
          @delTips="delTips"
          @addTip="addTip"
          @showLoading="showLoading"
          v-for="(item, index) in cartList"
          :key="index"
          :index="index"
          :config="item"
          orderType="cart"
        ></rCartOrder>
        <div style="margin-top: 10px"></div>
        <Spin size="large" fix v-if="spinShow"></Spin>
        <!-- <div v-if="pages == params.pageNum" style="margin: 10px 0">
          {{ $t("noMore") }}
        </div> -->
        <rNull
          v-if="cartList.length == 0 && spinShow == false"
          imgStyle="width:300px;margin:0 auto"
          titleStyle="font-size:16px;color:#999"
          :title="$t('noResult')"
        ></rNull>
        <div class="select-all common-flex common-align-center common-justify-between">
          <Checkbox @on-change="changeAll" v-model="allCheck">
            {{ $t("user.selectAll") }}
          </Checkbox>
          <Page
            v-if="total>0"
            :total="total"
            @on-change="changePage"
            show-sizer
            @on-page-size-change="changeSize"
            :page-size="params.pageSize"
            :page-size-opts="[20, 40, 60, 80]"
            show-total
          >
            <span>{{ $t("total") }} {{ total }} {{ $t("recoprds") }}</span>
          </Page>
          <div>
            {{ $t("user.check") }}: {{ ids.split(",").length - 1 }}
            {{ $t("user.items") }}
          </div>
        </div>
      </div>
    </div>
    <div class="total-price-box">
      <div
        class="total-price common-rowUnder"
        :style="
          isFixed
            ? {
                position: 'fixed',
                top: 0,
                height: '100vh',
                overflowY: 'auto',
              }
            : {}
        "
      >
        <div class="total">
          <div
            style="margin: 15px 0"
            class="common-flex common-justify-between"
          >
            <!-- this.showPrice.memberBalance = res.data.memberBalance
        this.showPrice.orderPrice = res.data.orderPrice -->
            <div class="title">{{ $t("saveItems.subTotal") }}</div>
            <div class="all-price">{{ showPrice.orderPrice }}</div>
          </div>
          <div class="common-flex common-justify-between">
            <div class="title">{{ $t("saveItems.accountBalance") }}</div>
            <div class="true-price">{{ showPrice.memberBalance }}</div>
          </div>
          <!-- {{subTotal}}{{accountBalance}} -->
          <div class="tips" v-if="Number(subTotal) > Number(accountBalance)">
            {{ $t("cart.moreBalance") }}
          </div>
          <Button
            v-if="ids == ''"
            style="
              margin-top: 15px;
              width: 220px;
              background: #b5bac4;
              color: #fff;
            "
          >{{ $t("saveItems.checkOut") }}
          </Button
          >
          <!-- {{ids}} -->
          <Button
            @click="submit"
            v-if="ids != ''"
            :style="
              Number(subTotal) > Number(accountBalance) ? { opacity: '.7' } : {}
            "
            style="
              margin-top: 15px;
              width: 220px;
              background: #0a4dcc;
              color: #fff;
            "
          >{{ $t("saveItems.submit") }}
          </Button
          >
        </div>
        <div class="products">
          <div class="title">{{ $t("saveItems.continueShopping") }}</div>
          <div class="common-flex common-flex-wrap common-justify-between">
            <div
              style="margin-top: 25px"
              v-for="(item, index) in recommendClothList"
              :key="index"
            >
              <img class="img" :src="item.url" alt="" srcset=""/>
              <div class="name">{{ item.name }}</div>
              <div class="options common-hover" @click="toOrder(item)">
                {{ $t("saveItems.gotoOrder") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <rChooseAddress
      :addressShow="addressShow"
      @handlerAddressShow="handlerAddressShow"
    ></rChooseAddress>
    <!-- 搜索弹框 -->
    <rOrderFilter
      :params="params"
      @search="search"
      @close="closeFilte"
      types="20"
      :filteShow="orderfilteShow"
    ></rOrderFilter>
    <!-- tips -->
    <rEditTipModal
      @updateCart="updateCart"
      :chooseOrderId="chooseOrderId"
      :chooseContent="chooseContent"
      tipType="cart"
      :tipShow="tipShow"
      @handlerTipShow="handlerTipShow"
    ></rEditTipModal>
    <!-- 客户详情 -->
    <rCustomerDetails
      @editMsg="editMsg"
      :customerMsg="customerMsg"
      :detailsShow="detailsShow"
      @handlerDetails="handlerDetails"
    ></rCustomerDetails>
    <!-- 提交订单等待弹框 -->
    <rSubmitWait
      @close="closeWait"
      :submitIds="submitIds"
      :submitShow="submitShow"
      @handlerSubmitShow="handlerSubmitShow"
    ></rSubmitWait>
    <Modal
      v-model="orderDetails"
      style="height: 90%"
      footer-hide
      fullscreen
      title=""
    >
      <div class="title-box">
        <div class="title">{{ $t("saveItems.CheckOptions") }}</div>
        <div
          @click="closeDetails"
          class="common-hover iconfont iconguanbi"
        ></div>
      </div>
      <rOrderDetails
        :config="orderMsg"
        :hideStep="true"
        detailsType="picture"
      ></rOrderDetails>
    </Modal>
    <rConsumptionQuery @uodateList="uodateList" :consumptionQueryConfig="consumptionQueryConfig" @hideShow="hideShow"
                       :consumptionQueryShow="consumptionQueryShow"></rConsumptionQuery>
  </div>
  <!-- </Scroll> -->
  <!-- </div> -->
</template>

<script>
let iTime;
import dayjs from 'dayjs'
import rNull from "../../components/r-null";
import rConsumptionQuery from "../../components/r-consumption-query";
import rCenterHeader from "../../components/r-center-header";
import rCartOrder from "../../components/r-cart-order";
import rChooseAddress from "../../components/r-choose-address-modal";
import rOrderFilter from "../../components/r-order-filter";
import rEditTipModal from "../../components/r-edit-tip-modal";
import rCustomerDetails from "../../components/r-customer-details";
import rSubmitWait from "../../components/r-submit-wait";
import rOrderDetails from "../../components/r-order-details";
import {mapActions} from "vuex";
import {exportOrderList} from '../../api/logistics'
import {clearHttpRequestingList} from '../../libs/util'

export default {
  name: "save-items",
  data() {
    return {
      consumptionQueryConfig: {},
      appearanceList: [],
      whetherTwice: [],
      // 隐藏显示
      consumptionQueryShow: false,
      orderNums: "",
      loading: false,
      orderNumList: [],
      // orderNumListCopy: [],
      allCheck: false,

      isFixed: false,
      recommendClothList: [], //推荐列表
      scrollHeight: 0,
      ids: "",
      pages: "",
      submitIds: [],
      // 选择内容
      chooseContent: "",
      // 选择添加标签的订单id
      chooseOrderId: "",
      lastAddTime: undefined,
      lastAddNum: 0,
      lastMoveTime: undefined,
      lastMoveNum: 0,
      // 订单详情
      orderMsg: "",
      customerMsg: "",
      spinShow: false,
      // 参数  params
      showPrice: {
        memberBalance: 0,
        orderPrice: 0,
      },
      params: {
        pageSize: 20,
        pageNum: 1,
        type: 1,
        userId: "", //账号
        status: "", //状态
        start: "", //开始时间
        end: "", //结束时间
        sizeCategoryId: "", //订单尺寸
        clothId: "", //当前选中产品id
        orderType: "", //订单类型
        keyWord: "",
        labelIds: '',
      },
      // 商品价格
      total: 0,
      subTotal: 0,
      // 账户余额
      accountBalance: 0,
      // 购物车列表
      cartList: [],
      // 订单详情
      orderDetails: false,
      // 提交弹框
      submitShow: false,
      //   用户详情
      detailsShow: false,
      //   提示消息弹框
      tipShow: false,
      // 分类弹框是否显示
      orderfilteShow: false,
      value: "",
      // 是否显示地址列表
      addressShow: false,
      // 头部面包屑
      headerMenu: [
        {
          name: this.$t("customer.crumbs.saveItems"),
        },
      ],
    };
  },
  components: {
    rCenterHeader,
    rChooseAddress,
    rOrderFilter,
    rCartOrder,
    rEditTipModal,
    rCustomerDetails,
    rSubmitWait,
    rOrderDetails,
    rNull,
    rConsumptionQuery
  },
  created() {
    let queryParam = sessionStorage.getItem("QM_SO");
    if (queryParam) {
      sessionStorage.removeItem("QM_SO");
      this.params = JSON.parse(queryParam);
      if (this.params.keyWord !== '') {
        this.orderNums = this.params.keyWord;
      }
    } else {
      this.params.keyWord = this.$route.query.orderNum
      this.orderNums = this.$route.query.orderNum
    }
    this.getOrderCartList();
    this.changeCheck();
    this.getRecommendClothList();
    this.scrollHeight = document.documentElement.clientHeight - 62;
    window.addEventListener("scroll", this.handleScroll); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  },
  watch: {
    cartList: {
      handler(newval, oldval) {
        let pass = true;
        newval.map((item) => {
          if (item.check == 0) {
            pass = false;
          }
        });
        this.allCheck = pass;
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    //在组件生命周期结束的时候销毁。
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    ...mapActions([
      "getOrderCartListAction", //购物车列表
      "getOrderCustomerByIdAction", //订单客户编号
      "updateOrderCustomerByIdAction", //编辑订单客户
      "getCartOrderDetailAction", //购物车详情列表
      "updateOrderAction", //删除订单
      "updateOrderAddproductAction", //追加西裤
      "updateCartOrderAmountAction", //修改购物车数量
      "getOrderSumPriceAction", //计算购物车价格
      // "pushOrderAction", //提交订单
      "saveOrderLabelsAction", //关联订单标签
      "getRecommendClothListAction", //购物车推荐
      "getOrderCodeListAction", //订单号列表
      "getOrderFormulaAction", //订单号计价公式
      // "getOrderSearchAction", //字典
    ]),
    // getOrderSearch(){
    //   this.getOrderSearchAction({
    //     category:14
    //   }).then(res=>{
    //     this.appearanceList = res.data
    //   })
    //   this.getOrderSearchAction({
    //     category:12
    //   }).then(res=>{
    //     this.whetherTwice = res.data
    //   })
    // },
    // 计价公式
    getOrderFormula() {
      this.getOrderFormulaAction()
    },
    hideShow() {
      this.consumptionQueryShow = false
    },
    // 单耗 弹框
    consumptionQuery(e) {
      this.consumptionQueryConfig = e
      this.consumptionQueryShow = true
    },
    clear() {
      this.params.pageNum = 1
      this.params.keyWord = ''
      this.getOrderCartList()
    },
    uodateList() {
      // this.getOrderCartList()

    },
    changeMethod(e) {
      let type = ''
      this.orderNumList.map(item => {
        if (e.label == item.orderCode) {
          type = item.source
        }
      })
      if (type == '我的订单') {
        this.$router.push('./underProduction?orderNum=' + e.label)
      } else if (type == '审核中订单') {
        this.$router.push('./myOrder?orderNum=' + e.label)
      } else {
        this.params.keyWord = e.label
        this.getOrderCartList();
      }
    },
    remoteMethod(e) {
      // let that = this;
      if (this.orderNums === e) {
        return;
      }
      clearHttpRequestingList();
      this.loading = true;
      this.getOrderCodeListAction({keyWord: e,}).then((res) => {
        this.loading = false;
        this.$set(this, "orderNumList", res.data);
      })
        .finally((res) => {
          this.loading = false;
        });
    },
    // 修改页数
    changePage(e) {
      this.params.pageNum = e;

      this.getOrderCartList();
    },
    // 修改条数
    changeSize(e) {
      this.params.pageSize = e;

      this.getOrderCartList();
    },
    changeAll() {
      this.cartList.map((item) => {
        item.check = Number(this.allCheck);
      });
      this.changeCheck();
    },
    // 跳转
    toOrder(e) {
      if (e.type == 8) {
        this.$router.push({
          path: "./newOrder",
          query: {
            id: e.id,
          },
        });
      } else {
        this.$router.push({
          path: "./peofessionalOrder",
          query: {
            id: e.id,
          },
        });
      }
    },
    // 购物车推荐
    getRecommendClothList() {
      this.getRecommendClothListAction().then((res) => {
        this.recommendClothList = res.data;
      });
    },

    // 滚动到底部
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量
      //变量windowHeight是可视区的高度
      let offsetTop = document.querySelector(".total-price").offsetTop + 70; // 要滚动到顶部吸附的元素的偏移量
      this.isFixed = scrollTop > offsetTop ? true : false; // 如果滚动到顶部了，this.isFixed就为true
      // let windowHeight =
      //   document.documentElement.clientHeight || document.body.clientHeight;
      // //变量scrollHeight是滚动条的总高度
      // let scrollHeight =
      //   document.documentElement.scrollHeight || document.body.scrollHeight;
      // //滚动条到底部的条件
      // if (scrollTop + windowHeight >= scrollHeight - 10) {
      //   //到了这个就可以进行业务逻辑加载后台数据了
      //   if (this.pages > this.params.pageNum) {
      //     this.params.pageNum++;
      //     // this.customer();
      //     this.getOrderCartList();
      //   }
      // }
    },
    // 下拉到底部
    handleReachEdge() {
      if (this.params.pageNum < this.pages) {
        this.params.pageNum++;
        this.getOrderCartList();
      }
    },
    // 关闭等待
    closeWait() {
      this.submitShow = false;
      this.params.pageNum = 1;
      // this.getOrderCartList();
    },
    // s更新购物车
    updateCart(isDel) {
      if (!isDel) {
        this.tipShow = false;
      }
      this.params.pageNum = 1;
      this.getOrderCartList();
    },
    // 删除标签
    delTips(labelItem) {
      this.spinShow = true;
      // 从订单的标签列表中删除特定标签
      const orderId = labelItem.orderId;
      const labelIdToRemove = labelItem.id;

      debugger
      // 找到对应的订单
      const order = this.cartList.find(item => item.orderId === orderId);
      if (!order || !order.labels) {
        this.spinShow = false;
        return;
      }

      // 过滤出其他标签
      const remainingLabelIds = order.labels
        .filter(label => label.id !== labelIdToRemove)
        .map(label => label.id)
        .join(',');

      this.saveOrderLabelsAction({
        orderId: orderId,
        labelIds: remainingLabelIds
      })
        .then((res) => {
        if (res.code == 0) {
            this.$Message.success('标签已删除');
          this.getOrderCartList();
          } else {
            this.$Message.error(res.message || '删除失败');
        }
        })
        .finally(() => {
          this.spinShow = false;
      });
    },
    // 删除订单
    deleteOrder(e) {
      this.updateOrderAction({
        orderId: e.orderId,
      }).then((res) => {
        if (res.code == 0) {
          this.cartList = [];
          this.params.pageNum == 1;
          this.getOrderCartList();
        }
      });
    },
    // 是否追加西裤
    changeAdd(e, config, index) {
      this.updateOrderAddproductAction({
        orderId: config.orderId,
        addProduct: Number(e),
      })
        .then((res) => {
          if (res.code == 0) {
            config.price = res.data;
            this.changeCheck();
          }
        })
        .catch((res) => {
          config.price = config.oldPrice;
          if (config.addProduct == 0) {
            config.addProduct = 1;
          } else {
            config.addProduct = 0;
          }
          this.changeCheck();
        });
    },
    changeCheck() {
      this.ids = "";

      this.cartList.map((item) => {
        if (item.check == 1) {
          this.ids = this.ids + item.orderId + ",";
        }
      });
      this.getOrderSumPriceAction({orderId: this.ids}).then((res) => {
        this.showPrice.memberBalance = res.data.memberBalance;
        this.showPrice.orderPrice = res.data.orderPrice || 0;
        this.accountBalance = res.data.memberBalance.slice(1);
        if (res.data.orderPrice) {
          this.subTotal = res.data.orderPrice.slice(1) || 0;
        } else {
          this.subTotal = 0;
        }
      });
    },
    // 回车搜索
    searchs() {
      this.params.keyWord = this.$refs.orderNumSelect.lastRemoteQuery
      this.orderNumList.push(
        {
          orderCode: this.params.keyWord,
          source: "",
        }
      )
      this.orderNums = this.$refs.orderNumSelect.lastRemoteQuery
      this.params.pageNum = 1;
      this.getOrderCartList();
    },
    // 搜索当前列表
    search(e) {
      if (e) {
        this.params = e;
      }
      this.params.pageNum = 1;
      this.closeFilte();
      this.getOrderCartList();
    },

    // 减少数量
    move(e) {
      let that = this;
      if (e.amount > 1) {
        e.amount--;
        clearTimeout(iTime);
        iTime = setTimeout(function () {
          that
            .updateCartOrderAmountAction({
              amount: e.amount,
              orderId: e.orderId,
            })
            .then((res) => {
              if (res.code == 0) {
                e.oldAmount = e.amount;
                e.price = res.data;
                that.changeCheck();
              }
            })
            .catch((res) => {
              e.amount = e.oldAmount;
              e.oldPrice = e.oldPrice;
              that.changeCheck();
            });
        }, 500);
      }
    },
    // 新增数量。
    add(e) {
      let that = this;
      e.amount++;
      clearTimeout(iTime);
      iTime = setTimeout(function () {
        that
          .updateCartOrderAmountAction({
            amount: e.amount,
            orderId: e.orderId,
          })
          .then((res) => {
            if (res.code == 0) {
              e.oldAmount = e.amount;
              e.price = res.data;
              that.changeCheck();
            }
          })
          .catch((res) => {
            e.amount = e.oldAmount;
            e.oldPrice = e.oldPrice;
            that.changeCheck();
          });
      }, 500);
    },
    // 购物车列表
    getOrderCartList: function () {
      let that = this;
      this.spinShow = true;
      this.getOrderCartListAction(this.params)
        .then((res) => {
          this.total = res.total;
          res.data.map((item) => {
            item.oldAmount = item.amount;
            item.oldPrice = item.price;
            item.check = 0;
          });
          // if (this.params.pageNum == 1) {
          this.cartList = res.data;
          // } else {
          //   this.cartList = this.cartList.concat(res.data);
          // }
          this.pages = res.pages;
          this.changeCheck();
        })
        .finally(function () {
          that.spinShow = false;
        });
    },
    // 提交编辑的订单信息
    editMsg() {
      this.updateOrderCustomerByIdAction(this.customerMsg).then((res) => {
        if (res.code == 0) {
          this.params.pageNum = 1;
          this.detailsShow = false;
          this.getOrderCartList();
        }
      });
    },
    // 提交
    submit() {
      if (Number(this.accountBalance) >= Number(this.subTotal)) {
        this.submitShow = true;
        this.submitIds = [];
        this.cartList.map((item) => {
          if (item.check == 1) {
            this.submitIds.push({
              orderId: item.orderId,
              orderCode: item.orderCode,
              status: 0, //0 未上传  1上传中  2成功  3失败
              msg: "",
            });
          }
        });
      }
      // pushOrderAction
    },
    // 弹框是否显示
    handlerSubmitShow() {
      this.submitShow = false;
    },
    // 订单详情 操作
    checkOptions(e) {
      this.getCartOrderDetailAction({
        orderId: e.orderId,
      }).then((res) => {
        this.orderDetails = true;
        this.orderMsg = res.data;
      });
    },
    // 隐藏订单列表 操作
    closeDetails() {
      this.orderDetails = false;
    },

    //   用户详情
    customerDetails(e) {
      this.detailsShow = true;
      this.getOrderCustomerByIdAction({
        orderId: e.orderId,
      }).then((res) => {
        this.customerMsg = res.data;
      });
    },
    //  关闭详情
    handlerDetails() {
      this.detailsShow = false;
    },
    // 显示搜搜分类
    filterClick() {
      this.orderfilteShow = true;
    },
    // 修改tip
    changeTip(e) {
      this.tipShow = true;
      this.chooseOrderId = e.orderId;
      this.chooseContent = e.labels || [];
    },
    // 修改tip
    addTip(e) {
      this.tipShow = true;
      this.chooseOrderId = e.orderId;
      this.chooseContent = e.labels || [];
    },
    //   隐藏tip
    handlerTipShow() {
      this.tipShow = false;
    },
    // 显示搜搜分类
    filterClick() {
      this.orderfilteShow = true;
    },
    // 关闭搜索分类
    closeFilte() {
      this.orderfilteShow = false;
    },
    //   选择地址弹框显示
    chooseAddress() {
      this.addressShow = true;
    },
    //   取消弹框
    handlerAddressShow() {
      this.addressShow = false;
    },
    // 购物车编辑
    handleCartEdit(cartItem) {
      let param = {
        id: cartItem.clothCategory,
        orderId: cartItem.orderId,
      };
      sessionStorage.setItem("QM_SO", JSON.stringify(this.params));
      if (cartItem.orderType === 8) {
        this.$router.push({
          path: '/peofessionalOrder',
          query: {...param, ...{sizeCategoryId: cartItem.sizeCategoryId}}
        });
      } else if (cartItem.orderType === 7) {
        this.$router.push({path: '/newOrder', query: {...param, ...{type: cartItem.orderType}}});
      } else if (cartItem.orderType === 10) {
        this.$router.push({path: '/styleOrdering', query: {...param, ...{type: cartItem.orderType}}});
      }

      // this.$router.push(
      //   `/peofessionalOrder?id=${clothCategory}&orderId=${orderId}&sizeCategoryId=${sizeCategoryId}&orderType=buyagain`
      // );
      // window.open(routerJump.href, '_blank')
    },
    // 再次购买
    handleBuyAgain(cartItem) {
      let param = {
        orderType: 'buyagain',
        id: cartItem.clothCategory,
        orderId: cartItem.orderId,
      }, routerJump;

      if (cartItem.orderType === 8) {
        routerJump = this.$router.resolve({
          path: '/peofessionalOrder',
          query: {...param, ...{sizeCategoryId: cartItem.sizeCategoryId}}
        });
      } else if (cartItem.orderType === 7) {
        routerJump = this.$router.resolve({path: '/newOrder', query: {...param, ...{type: cartItem.orderType}}});
      } else if (cartItem.orderType === 10) {
        routerJump = this.$router.resolve({path: '/styleOrdering', query: {...param, ...{type: cartItem.orderType}}});
      }
      window.open(routerJump.href, '_blank')
    },
    // 导出
    async handleExport() {
      let params = this.params
      let response = await exportOrderList(params);
      var url = window.URL.createObjectURL(
        new Blob([response.data], {type: "application/application/vnd.ms-excel"})
      );
      let link = document.createElement("a");
      let name = `购物车列表${dayjs(new Date()).format("YYYY-MM-DD")}.xls`;
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    },
    showLoading(spinShow) {
      this.spinShow = spinShow;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/ .ivu-icon-ios-close {
  display: none;
}

/deep/ .ivu-modal-body {
  padding: 0;
}

/deep/ .ivu-modal-content {
  border-radius: 0;
}

.search {
  /deep/ .ivu-select-single .ivu-select-input {
    height: 40px;
  }

  /deep/ .ivu-select-selection {
    height: 40px;
  }
}

.title-box {
  height: 84px;
  text-align: center;
  font-size: 20px;
  font-family: Roboto;
  font-weight: 600;
  color: #081938;
  line-height: 84px;
  letter-spacing: 2px;
  // line-height: 84px;
  border-bottom: 1px solid #e6e8eb;
  position: relative;

  .iconguanbi {
    width: 84px;
    height: 84px;
    text-align: center;
    line-height: 84px;
    font-size: 14px;
    color: #081938;
    position: absolute;
    right: 0;
    top: 0;
    border-left: 1px solid #e6e8eb;
  }
}

.save-items {
  width: 1440px;
  margin: 0 auto;
  padding-top: 10px;
  position: relative;

  .filter {
    background: #f8f8f8;
    border: none;
    color: #081938;
    margin-left: 5px;
    width: 85px;
    font-size: 14px;
  }

  .list {
    width: 1150px;
    margin-top: -10px;
    position: relative;

    .product-list {
      width: 1150px;
      min-height: 100vh;
      position: relative;
      margin: 0 auto 20px;
      background: #fff;
      padding: 10px 20px 60px;

      .select-all {
        position: fixed;
        height: 60px;
        width: 1150px;
        bottom: 0;
        left: 0;
        right: 290px;
        margin-left: auto;
        margin-right: auto;
        background: #ffffff;
        box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.04);
        padding: 14px 30px;
        z-index: 10

      }
    }
  }

  .total-price-box {
    position: relative;
    height: 100vh;
    width: 260px;
  }

  .total-price {
    // position: fixed;
    // margin-right: 0;
    // right: 0;
    .total {
      width: 260px;
      padding: 25px 20px;
      background: #fff;
      border-top: 3px solid #0a4dcc;
      // margin-top: 10px;
      .tips {
        width: 220px;
        font-size: 12px;
        color: #cc170a;
        text-align: left;
        // margin-bottom: 15px;
        margin-top: 13px;
      }

      .title {
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        color: #000000;
        line-height: 19px;
      }

      .all-price {
        font-size: 20px;
        font-weight: 700;
        text-align: left;
        color: #081938;
        line-height: 24px;
      }

      .true-price {
        font-size: 14px;
        font-weight: 700;
        text-align: left;
        color: #0a4dcc;
        line-height: 16px;
      }
    }

    .products {
      width: 260px;
      padding: 20px;
      background: #fff;
      margin-top: 10px;

      .title {
        font-size: 12px;
        font-weight: 600;
        text-align: left;
        color: #000000;
        line-height: 14px;
      }

      .img {
        width: 104px;
        height: 104px;
      }

      .name {
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: #000000;
        line-height: 14px;
        margin: 12px 0 6px;
      }

      .options {
        font-size: 12px;
        font-weight: 400;
        text-decoration: underline;
        text-align: center;
        color: #0a4dcc;
        line-height: 14px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/saveItems/saveItems.vue